module.exports = __webpack_public_path__ + "media/images/img-hobby-14-4a5cd647.jpg";